export const NEW_RELIC_LOGGING_EVENT = {
  channelType: 'web',
  logger: 'business_process_logger',
  orderToCash: 'order_to_cash',
  originService: 'on-frontend',
}

export const NEW_RELIC_EVENTS = {
  addPromoCode: 'add_promo_code',
  completePayment: 'complete_payment',
  removePromoCode: 'remove_promo_code',
  submitBillingAddress: 'submit_billing_address',
  submitPayment: 'submit_payment',
  submitShippingAddress: 'submit_shipping_address',
  submitShippingMethod: 'submit_shipping_method',
}
